import { render, staticRenderFns } from "./status-dropdown.vue?vue&type=template&id=c4b66250"
import script from "./status-dropdown.vue?vue&type=script&lang=js"
export * from "./status-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports